/**
 * Toasts Handler
 */
const toaster = {
    // Remove all children, except the first (which is the template)
    clear: () => {
        const toasts = document.querySelectorAll('.toast:not(:first-child)');
        toasts.forEach(toast => toast.remove());
    },
    // Render a toast with given message and bootstrap color class -- private closure
    toast: (() => {
        // The template for toasting is always the same
        const toastTemplate = document.querySelector('.toast-template');
        // The container which contains the toasts is also always the same
        const toastContainer = document.querySelector('.toast-container');

        if (!toastTemplate || !toastContainer) {
            return () => {};
        }

        // Return the actual function
        return (msg, title, options, type = 'default') => {
            // Defaults
            let delay = 5500;
            let autoHide = true;
            let callback = null;
            let closeOnClick = true;
            let append = true;
            let ariaLive = 'polite';
            let toastClass, alertClass, iconClass, closeClass, textClass = '';

            // Check if template already has values
            delay = toastTemplate.getAttribute('data-bsDelay') ?? delay;
            autoHide = toastTemplate.getAttribute('data-bsAutohide') ?? autoHide;

            // Check if options are an object
            if (options && typeof options === 'object') {
                autoHide = options.autoHide ?? autoHide;
                delay = options.delay ?? delay;
                callback = options.callback ?? callback;
                closeOnClick = options.closeOnClick ?? closeOnClick;
                append = options.append ?? append;
            }

            switch (type) {
                case 'primary':
                    toastClass = 'bg-primary';
                    alertClass = 'alert-primary';
                    iconClass = 'fa-bell';
                    textClass = 'text-white';
                    break;
                case 'secondary':
                    toastClass = 'bg-secondary';
                    alertClass = 'alert-secondary';
                    iconClass = 'fa-bell';
                    textClass = 'text-white';
                    break;
                case 'info':
                    toastClass = 'bg-info';
                    alertClass = 'alert-info';
                    iconClass = 'fa-info-circle';
                    textClass = 'text-dark';
                    break;
                case 'success':
                    toastClass = 'bg-success';
                    alertClass = 'alert-success';
                    iconClass = 'fa-check-circle';
                    closeClass = 'btn-close-white';
                    textClass = 'text-white';
                    break;
                case 'warning':
                    toastClass = 'bg-warning';
                    alertClass = 'alert-warning';
                    iconClass = 'fa-exclamation-circle';
                    textClass = 'text-dark';
                    ariaLive = 'assertive';
                    break;
                case 'danger':
                    toastClass = 'bg-danger';
                    alertClass = 'alert-danger';
                    iconClass = 'fa-circle-xmark';
                    closeClass = 'btn-close-white';
                    textClass = 'text-white';
                    ariaLive = 'assertive';
                    break;
                default:
                    toastClass = 'bg-light';
                    alertClass = 'alert-light';
                    iconClass = 'fa-bell';
                    textClass = 'text-dark';
                    break;
            }

            // Clone the template
            const toast = toastTemplate.cloneNode(true);
            if (!toast) {
                console.error('Failed to clone toast template.');
                return;
            }

            // Is this an alert or a toast style?
            if (toast.classList.contains('alert')) {
                // Handle toast or alert style
                toast.classList.add(alertClass, textClass);

                // Handle icons in alert style
                const alertIcon = toast.querySelector('.alert-icon i');
                if (alertIcon) {
                    alertIcon.classList.add(iconClass);
                }

                // Set the message in alert style
                const alertMessage = toast.querySelector('.alert-message');
                if (alertMessage) {
                    alertMessage.innerHTML = msg;
                }

            } else {
                // Handle icons in toast style
                const toastHeaderIcon = toast.querySelector('.toast-header i');
                if (toastHeaderIcon) {
                    toastHeaderIcon.classList.add(iconClass);
                }

                // Set the title in toast style
                const toastHeader = toast.querySelector('.toast-header');
                if (toastHeader && title) {
                    toastHeader.classList.add(toastClass);
                    const strong = toastHeader.querySelector('strong');
                    if (strong) {
                        strong.innerHTML = title;
                    }
                    toastHeader.classList.add(textClass);
                } else {
                    // Handle default toast style
                    toast.classList.add(toastClass, textClass);
                }

                // Set the message in toast style
                const toastBody = toast.querySelector('.toast-body');
                if (toastBody) {
                    toastBody.innerHTML = msg;
                }
            }

            // Set the close button color
            const btnClose = toast.querySelector('.btn-close');
            if (btnClose && closeClass !== '') {
                btnClose.classList.add(closeClass);
            }

            // Remove the template class
            toast.classList.remove('toast-template');

            // Fire callback when toast is closed
            if (callback && typeof callback === 'function') {
                toast.addEventListener('hidden.bs.toast', callback);
            }

            // When clicked or tapped onto, close it
            if (closeOnClick) {
                toast.addEventListener('click', () => {
                    toast.remove();
                    // Fire callback when toast is closed
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                });
            }

            // Auto hide the toast after a certain time
            if (autoHide && delay > 0) {
                toast.setAttribute('data-bs-delay', delay);
                toast.setAttribute('data-bs-autohide', 'true');
            }

            // Set aria-live attribute
            toast.setAttribute('aria-live', ariaLive);

            // Append the toast to the container
            if (append) {
                toastContainer.append(toast);
            } else {
                toastContainer.prepend(toast);
            }

            const toastBoostrap = bootstrap.Toast.getOrCreateInstance(toast);
            toastBoostrap.show();
        }
    })(),

    // predefined color classes for easier usage
    default(msg, title, options){
        toaster.toast(msg, title, options, 'default');
    },
    info(msg, title, options){
        toaster.toast(msg, title, options, 'info');
    },
    success(msg, title, options) {
        toaster.toast(msg, title, options, 'success');
    },
    warning(msg, title, options) {
        toaster.toast(msg, title, options, 'warning');
    },
    error(msg, title, options) { 
        toaster.toast(msg, title, options, 'danger');
    }
};

// Note: If you want to make toaster globally available
window.toaster = toaster;

document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    const toasts = document.querySelectorAll('.toast:not(.toast-template)');
    toasts.forEach((toastElement) => {
        const toast = bootstrap.Toast.getOrCreateInstance(toastElement);
        toast.show();
    });
});